/* eslint-disable no-console */
import jwtAuth from '@it-enterprise/jwtauthentication'
import { clearCachedValues } from '@/api/localItemsCache'
import settings from '../../public/settings.json'

const OIDC_CLIENTID = settings.oidcClientId
const OIDC_AUTHORITY = settings.oidcAuthority
const OIDC_SCOPE = settings.oidcScopes
const API_URL = settings.wsPath
const BASE_URL = settings.baseUrl

const sessionStorageProxy = {
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),
  clear: () => localStorage.clear(),
  key: (index) => localStorage.key(index),
  get length() {
    return localStorage.length
  }
}

Object.defineProperty(window, 'sessionStorage', {
  get: () => sessionStorageProxy,
  configurable: true
})

jwtAuth.config({
  baseUrl: API_URL,
  webUrl: `${window.location.origin}${BASE_URL}`,
  loginUrl: `api/jwtlogin`,
  refreshUrl: `api/refreshtoken`,
  closeSessionUrl: `api/web.closesession`,
  oidc: OIDC_AUTHORITY
    ? {
      authority: OIDC_AUTHORITY,
      client: OIDC_CLIENTID,
      addScope: OIDC_SCOPE,
    }
    : undefined,
  silentRequestTimeoutInSeconds: 30,
  logger: {
    log: (message) => console.log(`Auth: ${message}`),
    debug: (message) => console.debug(`Auth: ${message}`),
    info: (message) => console.info(`Auth: ${message}`),
    warn: (message) => console.debug(`Auth: ${message}`),
    error: (message) => console.error(`Auth: ${message}`),
  },
  onError: (e) => {
    switch (true) {
    case e.response && e.response.status === 400:
      jwtAuth.clearTokens()
      clearCachedValues()
      window.location.reload()
      break
    case e.response && e.response.status <= 500:
      window.location.reload()
      break
    default:
      console.log(e)
    }
  },
})

let tokenPromise = null

async function getToken() {
  if (!tokenPromise) {
    tokenPromise = jwtAuth.getToken().finally(() => {
      tokenPromise = null
    })
  }
  return tokenPromise
}

export const auth = {
  ...jwtAuth,
  getToken,
  logout() {
    return jwtAuth.logout()
  },
  clearTokens() {
    return jwtAuth.clearTokens()
  },
  login(username, password, remember) {
    return jwtAuth.login(username, password, remember)
  },
  loginByCode(code) {
    return jwtAuth.loginByCode(code)
  },
  loginByOidc(config) {
    return jwtAuth.loginByOidc(config)
  },
  loginByOidcRedirectComplite(token) {
    return jwtAuth.loginByOidcRedirectComplite(token)
  },
  getOidcManager() {
    return jwtAuth._oidc || null
  },
}